// extracted by mini-css-extract-plugin
export default {"main":"_1d33fa260b","tit":"b7530546ce","maintitle":"cac3a6e74b","ylw":"ad2875d042","white":"_6699a6e172","mv_title":"_62f214d3f8","mv_nc":"_2639321b6a","mv_in":"_80dd1be89b"};